import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Rectangle,
} from "recharts";

const BarChartGraph = ({ data, activeTab }) => {
    const chartData = {
        Semana: [
            { name: "Lun", uv: 4000, pv: 2400, amt: 2400 },
            { name: "Mar", uv: 3000, pv: 1398, amt: 2210 },
            { name: "Mié", uv: 2000, pv: 9800, amt: 2290 },
            { name: "Jue", uv: 2780, pv: 3908, amt: 2000 },
            { name: "Vie", uv: 1890, pv: 4800, amt: 2181 },
        ],
        Mes: [
            { name: "Sem 1", uv: 15000, pv: 12000, amt: 11000 },
            { name: "Sem 2", uv: 18000, pv: 14000, amt: 13000 },
            { name: "Sem 3", uv: 16000, pv: 13500, amt: 12500 },
            { name: "Sem 4", uv: 20000, pv: 16000, amt: 15000 },
        ],
        Año: [
            { name: "Q1", uv: 40000, pv: 24000, amt: 24000 },
            { name: "Q2", uv: 30000, pv: 13980, amt: 22100 },
            { name: "Q3", uv: 20000, pv: 98000, amt: 22900 },
            { name: "Q4", uv: 27800, pv: 39080, amt: 20000 },
        ],
    };

    const BAR_COLORS = ["#0b6775", "#5599a3", "#ff7300", "#82ca9d", "#ffc658"];
    const ACTIVE_BAR_COLORS = [
        "#042327",
        "#083f47",
        "#a64b00",
        "#5a8d6b",
        "#b38b3d",
    ];

    const formatLegendName = (key) => {
        const result = key.replace(/([A-Z])/g, " $1");
        return result.charAt(0).toUpperCase() + result.slice(1);
    };

    console.log("Data prop in BarChartGraph:", data);

    const displayData = data?.[activeTab] || chartData[activeTab] || [];

    const barKeys =
        displayData.length > 0
            ? Object.keys(displayData[0]).filter((key) => key !== "name")
            : [];

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                display: "block",
                position: "relative",
            }}
        >
            <ResponsiveContainer
                width="100%"
                height="100%"
                minWidth={0}
                minHeight={0}
            >
                <BarChart
                    data={displayData}
                    margin={{
                        top: 0,
                        right: 0,
                        left: 0,
                        bottom: 0,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                    <XAxis
                        dataKey="name"
                        tick={{ fontSize: 11, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                        padding={{ left: 0, right: 0 }}
                    />
                    <YAxis
                        tick={{ fontSize: 11, fill: "#666" }}
                        axisLine={false}
                        tickLine={false}
                        width={40}
                    />
                    <Tooltip
                        contentStyle={{
                            backgroundColor: "#fff",
                            border: "none",
                            borderRadius: "8px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: "14px",
                        }}
                        labelStyle={{
                            fontSize: "14px",
                            fontWeight: "600",
                            color: "#333",
                            marginBottom: "8px",
                        }}
                    />
                    <Legend
                        wrapperStyle={{
                            fontSize: "14px",
                            color: "#666",
                            paddingTop: "10px",
                        }}
                    />
                    {barKeys.map((key, index) => (
                        <Bar
                            key={key}
                            dataKey={key}
                            name={formatLegendName(key)}
                            fill={BAR_COLORS[index % BAR_COLORS.length]}
                            radius={[4, 4, 0, 0]}
                            activeBar={
                                <Rectangle
                                    fill={
                                        ACTIVE_BAR_COLORS[
                                            index % ACTIVE_BAR_COLORS.length
                                        ]
                                    }
                                />
                            }
                        />
                    ))}
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default BarChartGraph;
